<template>
  <div class="sc-preview-container">
    <div class="pc-preview-background">
      <img
        alt="phone-empty"
        src="@shared/assets/img/partner-detail/service-category.png"
        class="pc-phone-img"
      />
      <div class="pc-absolute-overlay">
        <ServiceCategoryItem
          v-if="serviceOffered.includes('HVAC')"
          title="HVAC"
          sub="HVAC Services"
          imageSrc="hvac"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Plumbing')"
          title="Plumbing"
          sub="Plumbing Services"
          imageSrc="plumbing"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Water Quality')"
          title="Water Quality"
          sub="Clean water services"
          imageSrc="water"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Septic')"
          title="Septic"
          sub="Septic system services"
          imageSrc="septic"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Electrical')"
          title="Electrical"
          sub="Power system services"
          imageSrc="electrical"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Garage Door')"
          title="Garage Door"
          sub="Garage door services"
          imageSrc="garage"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Air Quality')"
          title="Air Quality"
          sub="Something seems broken"
          imageSrc="air"
        />
        <ServiceCategoryItem
          v-if="serviceOffered.includes('Other')"
          title="Other"
          sub="Customized services"
          imageSrc="other"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceCategoryItem from './ServiceCategoryItem.vue';

export default {
  name: 'ServiceRequestServicesPreview',
  components: {
    ServiceCategoryItem,
  },
  props: {
    serviceOffered: Array,
  },
};
</script>

<style lang="scss">
.sc-preview-container {
  margin-left: 24px;

  .pc-preview-background {
    position: relative;
    border-radius: 50px;
    background-color: $N100;
    height: 91%;
  }

  .pc-phone-img {
    height: 520px;
  }

  .pc-phone-item {
    height: 50px;
    padding: 10px;
  }

  .pc-absolute-overlay {
    position: absolute;
    left: 15px;
    right: 15px;
    top: 80px;
    height: 400px;
    overflow: auto;
    padding: 6px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    .pc-bubble {
      background-color: #2b3757;
      width: 100%;
      height: 52px;
      border-radius: 4px;
      display: flex;
      align-items: center;

      &:not(:first-child) {
        margin-top: 4px;
      }

      .pc-phone-container {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        padding-top: 8px;

        .pc-phone-title {
          font-size: 12px;
          font-weight: bold;
          color: white;
        }

        .pc-phone-subtitle {
          font-size: 8px;
          color: white;
        }
      }
    }
  }

  .pc-preview-title {
    margin-top: 14px;
    text-align: center;
  }
}
</style>
